<template>
    <div>
        <div class="nav-container">
                <div class="nav">
                    <div class="box-row">
                        <div v-for="(item, index) in 19" :key="item" class="box1-wrapper2"
                            @click="goToVideoDetail(item)">
                            <div class="box1-b">
                                <!-- 使用导入的视频源 -->
                                <video :src="videoSource" controls muted preload="metadata" width="100%" height="100%"
                                    style="border-radius: 12px; 
                                object-fit: cover;">
                                    您的浏览器不支持视频播放。
                                </video>

                            </div>
                            <div class="box2-b">
                                <text>
                                    Thisisthetitleofthequestionbank
                                    <br>
                                    This is the title of the
                                </text>
                            </div>
                        </div>
                    </div>
                    <div class="logo-a">
                        <Arrowhead />
                    </div>
                </div>
            </div>
    </div>
</template>

<script setup>
import Arrowhead from '../components/Arrowhead.vue'
import videoSource from '../assets/videos/video.mp4'
import { useRouter } from 'vue-router';
const router = useRouter();
// 跳转到视频详情页并传递item数据
const goToVideoDetail = (item) => {

router.push({
    path: "/videosd",
    query: {
        item: JSON.stringify(item)
    }

});

}

</script>

<style  scoped>
@import '../pages/index-b.css'
</style>